const {createClient} = require("@supabase/supabase-js");

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
const supabaseKey = process.env.VUE_APP_SUPABASE_USER_KEY;

module.exports = {
    dbClient: (token) => {
        if (!token) {
            return createClient(supabaseUrl, supabaseKey)
        }else{
            //user based token
            console.log("user based client")
            return createClient(supabaseUrl, supabaseKey, {
                global: {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            })
        }
    }
};